import { Theme } from "./../styles";
import { DrawRowConfig } from "./../types/global";

export const drawRow = (config: DrawRowConfig, theme: Theme) => {
  const {
    ctx,
    x,
    y,
    width,
    height,
    textYPos,
    label,
    font,
    isBottomRow,
    fillStyle,
    topText,
    bottomText,
    labelBetweenCells
  } = config;

  ctx.beginPath();
  ctx.strokeStyle = '#E0E0E0';
  ctx.setLineDash([]);

  if (label && font && textYPos) {
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(x, y, width, height);

    if (labelBetweenCells) {
      ctx.moveTo(x, y);
      ctx.lineTo(x + width, y);
      ctx.stroke();

      ctx.moveTo(x, y + height);
      ctx.lineTo(x + width, y + height);
      ctx.stroke();

      ctx.moveTo(x + width / 2, y + height);
      ctx.lineTo(x + width / 2, y + height - 5);
      ctx.stroke();
    } else {
      ctx.strokeRect(x + 0.5, y + 0.5, width, height);
    }

    ctx.font = font;

    const textXPos = x + width / 2 - ctx.measureText(label).width / 2;
    ctx.textBaseline = "middle";
    ctx.fillStyle = '#616161';
    ctx.fillText(label, textXPos, textYPos);
  }
  if (isBottomRow && fillStyle && topText && bottomText) {
    ctx.fillStyle = fillStyle;
    ctx.fillRect(x, y, width, height);
    ctx.strokeRect(x + 0.5, y + 0.5, width, height);

    ctx.font = topText.font;

    const dayNameXPos = x + width / 2 - ctx.measureText(topText.label).width / 2;

    ctx.fillStyle = topText.color;
    ctx.fillText(topText.label, dayNameXPos, topText.y);

    ctx.font = bottomText.font;

    const dayNumXPos = x + width / 2 - ctx.measureText(bottomText.label).width / 2;

    ctx.fillStyle = '#9E9E9E';
    ctx.fillText(bottomText.label, dayNumXPos, bottomText.y);
  }
};
